// src/components/formularios/ConfirmExitFormularioDialog.tsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import gorilaWaitImg from '../../imagenes/Gorilas/gorila_wait.png';

interface Props {
  open: boolean;
  onClose: () => void;
  onDiscard: () => void;
  onSaveDraft: () => void;
  loading?: boolean;
}

export default function ConfirmExitFormularioDialog({
  open,
  onClose,
  onDiscard,
  onSaveDraft,
  loading = false,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(139, 69, 19, 0.5)',
            backdropFilter: 'blur(4px)',
          },
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: '12px',
          overflow: 'visible',
          position: 'relative',
        },
      }}
    >
      {/* Gorila en la esquina superior derecha */}
      <Box
        component="img"
        src={gorilaWaitImg}
        alt="Gorila Wait"
        sx={{
          position: 'absolute',
          right: '20px',
          top: '-150px',
          transform: 'translateX(0)',
          width: { xs: '150px', sm: '170px', md: '190px' },
          height: 'auto',
          zIndex: 10,
          pointerEvents: 'none',
        }}
      />
      <DialogTitle
        sx={{
          backgroundColor: '#000',
          color: '#fff',
          fontWeight: 'bold',
          borderTopLeftRadius: '12px',
          borderTopRightRadius: '12px',
          pr: { xs: 2, sm: 10 },
          mb: 3,
        }}
      >
        ¡Ey! No tan rápido...
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: '#fff', pt: 2, pb: 1 }}>
        <Typography variant="body1" color="text.primary" sx={{ mb: 0 }}>
          Antes de que abandones, ¿quieres guardar este formulario como <strong>BORRADOR</strong> y
          continuar más tarde?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ backgroundColor: '#fff', px: 3, py: 2, flexDirection: 'column', gap: 1, borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
        <Button
          onClick={onSaveDraft}
          disabled={loading}
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: '#21a598',
            color: '#fff',
            '&:hover': { backgroundColor: '#1a8578' },
            textTransform: 'uppercase',
            fontWeight: 'bold',
          }}
        >
          {loading ? 'Guardando...' : 'Guardar Borrador'}
        </Button>
        <Button
          onClick={onDiscard}
          disabled={loading}
          sx={{
            color: '#d32f2f',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: 'rgba(211, 47, 47, 0.08)',
            },
          }}
        >
          Prefiero no guardarlo
        </Button>
      </DialogActions>
    </Dialog>
  );
}
